"use client";

import React from "react";
import Hero from "../components/remotion-claude-guide/Hero";
import SocialProof from "../components/remotion-claude-guide/SocialProof";
import WhatYoullLearn from "../components/remotion-claude-guide/WhatYouLearn";
import WhyDifferent from "../components/remotion-claude-guide/WhyDifferent";
import DownloadSection from "../components/remotion-claude-guide/DownloadSection";
import NewsletterSection from "../components/remotion-claude-guide/NewsletterSection";
import PeerQuikPromo from "../components/grow-on-x/PeerQuikPromo";
import FAQ from "../components/remotion-claude-guide/FAQ";

const DOWNLOAD_URL = "/api/remotion-claude-guide/download";

const RemotionClaudeGuideLanding: React.FC = () => {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <SocialProof />
      <WhatYoullLearn />
      <WhyDifferent />
      <DownloadSection />
      <NewsletterSection />
      <PeerQuikPromo />
      <FAQ />

      <section className="bg-gradient-to-t from-gray-900 to-black text-white py-16 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-3xl font-bold mb-6">
            Ready to create videos with code?
          </h3>
          <a
            href={DOWNLOAD_URL}
            className="inline-block bg-cyan-400 hover:bg-cyan-300 text-black hover:text-black font-bold py-4 px-12 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg shadow-cyan-400/50"
          >
            Download the Free PDF
          </a>
          <p className="text-sm text-gray-400 mt-4">
            100% free · Instant access · No email required
          </p>
        </div>
      </section>
    </div>
  );
};

export default RemotionClaudeGuideLanding;
